import { Expose, Type } from '@nts/std/serialization';
import { LayoutDefinitionIdentity } from "./layout-definition.identity";

export class DraftLayoutInfoDto {
    @Expose()
    @Type(() => LayoutDefinitionIdentity)
    identity: LayoutDefinitionIdentity
}

